{
  "login": {
    "title": "Log In",
    "emailLabel": "Email address",
    "passwordLabel": "Password",
    "rememberMe": "Remember me for 30 days",
    "submitButton": "Login",
    "submittingButton": "Logging in...",
    "forgotPassword": "Forgot password?",
    "setNewPassword": "Set a new password here",
    "sessionExpired": "Session Expired",
    "noAccountYet": "No account yet?",
    "createOne": "Create one"
  },
  "forgotPassword": {
    "title": "Forgot Password",
    "emailLabel": "Email address",
    "submitButton": "Send reset password link to your email",
    "backToLogin": "Go back to Log in",
    "submittingButton": "Sending...",
    "successTitle": "Check your inbox",
    "successMessage": "If an account exists for this address, we sent a reset link to your email."
  },
  "confirmEmail": {
    "confirming": "Confirming your email…",
    "successTitle": "Email confirmed",
    "successMessage": "Your email address has been confirmed. You can now log in to your account.",
    "continueToLogin": "Continue to login",
    "errorTitle": "Confirmation failed",
    "errorMessage": "We couldn't confirm your email. The link may be invalid or expired."
  },
  "resetPassword": {
    "title": "Reset Password",
    "subtitle": "Enter your new password below",
    "newPasswordLabel": "New Password",
    "newPasswordPlaceholder": "Enter your new password",
    "confirmPasswordLabel": "Confirm New Password",
    "confirmPasswordPlaceholder": "Confirm your new password",
    "passwordsDoNotMatch": "Passwords do not match",
    "submitButton": "Set New Password",
    "submittingButton": "Resetting Password...",
    "invalidToken": "Invalid reset token",
    "fixRequirements": "Please fix password requirements",
    "failedReset": "Failed to reset password"
  },
  "acceptTerms": {
    "title": "Terms and Conditions",
    "subtitle": "Please review and accept our terms to continue",
    "welcomeTitle": "Welcome to Flipping Pal!",
    "welcomeBody": "These terms and conditions outline the rules and regulations for the use of Flipping Pal's Website, located at",
    "welcomeBody2": "By accessing this website we assume you accept these terms and conditions. Do not continue to use Flipping Pal if you do not agree to take all of the terms and conditions stated on this page.",
    "keyPointsTitle": "Key Points:",
    "keyPoints": {
      "0": "Flipping Pal owns all intellectual property rights for materials on this website",
      "1": "You may not republish, sell, or redistribute content from Flipping Pal",
      "2": "We use cookies to enhance your experience on our website",
      "3": "User comments do not reflect the views of Flipping Pal",
      "4": "We reserve the right to modify these terms at any time",
      "5": "Website content is provided \"as is\" without warranties"
    },
    "responsibilitiesTitle": "Your Responsibilities:",
    "responsibilities": {
      "0": "Use the service in accordance with all applicable laws",
      "1": "Maintain the security of your account credentials",
      "2": "Do not attempt to compromise the security of our systems",
      "3": "Respect intellectual property rights"
    },
    "previewNote": "📄 This is a preview of our Terms and Conditions. Click \"View Full Terms\" below to read the complete document.",
    "viewFullTerms": "View Full Terms and Conditions (opens in new tab)",
    "checkboxLabel": "I have read and agree to the Terms and Conditions",
    "checkboxDescription": "By checking this box, you acknowledge that you have read, understood, and agree to be bound by these terms.",
    "acceptButton": "Accept and Continue",
    "acceptingButton": "Accepting...",
    "questionsText": "Questions about our terms?",
    "contactSupport": "Contact support"
  },
  "discord": {
    "linkingTitle": "Linking Discord Account",
    "linkingBody": "Please wait while we connect your Discord account...",
    "successTitle": "Success!",
    "successBody": "Your Discord account has been linked successfully.",
    "successWindowClose": "This window will close automatically...",
    "successRedirect": "Redirecting you back to settings...",
    "errorTitle": "Linking Failed",
    "errorBody": "We couldn't link your Discord account.",
    "errorWindowClose": "This window will close automatically...",
    "errorRedirect": "Redirecting you back to settings...",
    "backToSettings": "Back to Settings"
  },
  "register": {
    "title": "Create Account",
    "subtitle": "Join us and start your journey today",
    "emailLabel": "Email Address",
    "emailPlaceholder": "Enter your email address",
    "passwordLabel": "Password",
    "passwordPlaceholder": "Create a strong password",
    "confirmPasswordLabel": "Confirm Password",
    "confirmPasswordPlaceholder": "Confirm your password",
    "passwordStrength": "Password Strength",
    "strengthStrong": "Strong",
    "strengthMedium": "Medium",
    "strengthWeak": "Weak",
    "termsLabel": "I agree to the",
    "termsLink": "Terms and Conditions",
    "termsLabel2": "",
    "submitButton": "Create Account",
    "submittingButton": "Creating Account...",
    "alreadyHaveAccount": "Already have an account?",
    "signInHere": "Sign in here",
    "registrationClosed": "Currently no registration possible",
    "registrationClosedMessage": "At the moment registration is closed",
    "fixFormErrors": "Please fix the form errors before submitting",
    "acceptTermsRequired": "Please accept the Terms and Conditions to continue",
    "registrationFailed": "Registration failed. Please try again."
  },
  "errorBoundary": {
    "title": "Something Went Wrong",
    "subtitle": "An unexpected error occurred. Don't worry — your data is safe.",
    "unknownError": "Unknown error",
    "goHome": "Go Home",
    "reloadPage": "Reload Page",
    "logout": "Logout",
    "showErrorDetails": "Show Error Details",
    "hideErrorDetails": "Hide Error Details",
    "copyToClipboard": "Copy to clipboard",
    "copied": "Copied!",
    "copy": "Copy",
    "errorLabel": "Error",
    "componentStackLabel": "Component Stack",
    "reference": "Reference"
  }
}
